export default "__VITE_ASSET__DqEAPEba__"